import React from 'react';
import { followUpText, nextStepText, isOverdue, localDateString, sideNoun, sinceText, stageLabel, statusLabel } from '../../utils/crmPipeline';
import { personDisplayName } from '../../utils/crm';

/** The name on a board card or Today row. */
export const cardName = (card) => personDisplayName({
  firstName: card.firstName,
  lastName: card.lastName,
  emails: card.email ? [{ value: card.email }] : [],
  phones: card.phone ? [{ value: card.phone }] : [],
  decryptionFailed: card.decryptionFailed,
});

/** One lead on the Today list. `actions` renders a right-aligned quick-action strip when set. */
const LeadRow = ({ card, onOpen, today = localDateString(), actions = null }) => {
  const overdue = isOverdue(card.nextFollowUpDate, today);
  return (
    <li className="crm-lead-row">
      <div className="crm-lead-body">
        <div className="crm-lead-main">
          <button type="button" className="crm-link" onClick={() => onOpen(card.personId)}>{cardName(card)}</button>
          <span className={`crm-pill crm-pill-${card.side === 'SELL' ? 'seller' : 'buyer'}`}>{sideNoun(card.side)}</span>
          <span className="crm-stage-tag">{stageLabel(card.stage)}</span>
          {card.status === 'NURTURING' && <span className="crm-stage-tag crm-tag-quiet">{statusLabel(card.status)}</span>}
        </div>
        {card.summary && <div className="crm-lead-summary">{card.summary}</div>}
        {card.status === 'OPEN' && <div className="crm-next-action">Next: {nextStepText(card.nextTask, card.stage, today)}</div>}
        <div className="crm-lead-meta">
          {card.nextFollowUpDate && (
            <span className={overdue ? 'crm-overdue' : ''}>Follow up: {followUpText(card.nextFollowUpDate, today)}</span>
          )}
          <span>{card.lastContactedAt ? `Last contact ${sinceText(card.lastContactedAt)}` : 'Not contacted yet'}</span>
          {!card.nextFollowUpDate && card.daysSinceContact != null && <span className="crm-overdue">{card.daysSinceContact} days with no follow-up</span>}
        </div>
      </div>
      {actions}
    </li>
  );
};

export default LeadRow;
